module.exports = __webpack_public_path__ + "static/media/msrating_107.8661c9ae.ico";